import { LinkButton } from '@/components/elements/forms/buttons/Button/Button';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '@/constants/downloadApp';
import { _t } from '@/locale';

export const FooterExternalLinks = ({ displayRow = false }: { displayRow?: boolean }) => {
  return displayRow ? (
    <div className="flex w-full flex-wrap justify-between">
      <LinkButton
        target="_blank"
        size="sm"
        variant="link"
        className="px-[0px!important] text-[#336CA8] underline"
        to="https://business.bokadirekt.se/">
        {_t('footerNavigation.b2b')}
      </LinkButton>
      <div className="flex flex-wrap gap-4">
        <a href={APP_STORE_URL}>
          <img src="/images/download-app-store.png" className="h-[40px]" alt={_t('availableAppStore')} />
        </a>
        <a href={GOOGLE_PLAY_URL}>
          <img src="/images/download-google-play.png" className="h-[40px]" alt={_t('availablePlayStore')} />
        </a>
      </div>
    </div>
  ) : (
    <div className="flex w-full flex-col gap-2 lg:max-w-[270px]">
      <p className="text-md mb-2 font-bold md:text-lg md:font-normal">{_t('footerNavigation.downloadApp')}</p>
      <div className="align-center justify-left mb-6 flex flex-wrap md:mb-12">
        <a href={APP_STORE_URL}>
          <img src="/images/download-app-store.png" className="mr-3 h-[40px]" alt={_t('availableAppStore')} />
        </a>
        <a href={GOOGLE_PLAY_URL}>
          <img src="/images/download-google-play.png" className="h-[40px]" alt={_t('availablePlayStore')} />
        </a>
      </div>
      <p className="text-md mb-2 font-bold md:text-lg md:font-normal">{_t('footerNavigation.b2b')}</p>
      <div className="md:items-left flex">
        <LinkButton
          target="_blank"
          variant="primary"
          size="md"
          className="w-full lg:w-auto"
          to="https://business.bokadirekt.se/">
          {_t('footerNavigation.b2bCTA')}
        </LinkButton>
      </div>
    </div>
  );
};
